export const MessagesIcons = {
  SEND: {
    Icon: 'tabler-send',
    Color: 'success',
  },
  RESEND: {
    Icon: 'tabler-send',
    Color: 'warning',
  },
  EDIT: {
    Icon: 'tabler-pencil',
    Color: 'primary',
  },
  DELETE: {
    Icon: 'tabler-trash',
    Color: 'error',
  },
  ADD_ATTACHMENTS: {
    Icon: 'tabler-paperclip',
    Color: 'warning',
  },
}
